// @flow
/* eslint-disable react/display-name */

import React, { memo, useCallback } from 'react'
import { useLocation } from 'react-router-dom'

import { useFocusable } from '@alphaott/smart-tv-spatial-navigation'

import { ChannelListControlFocusable, BackButton } from '../ChannelListControl'
import { ChannelCategoryCard } from './partials'

import { extractInfo } from './utils'

export type CategoryListControlProps = {
  title?: string,
  items: Array<any>,
  onSelectChannelsListItem: Function,
  onBackPress?: Function,
}

// $FlowFixMe
export const CategoryListControlPure = ({
  title,
  items = [],
  onSelectChannelsListItem,
  onBackPress,
}: CategoryListControlProps) => {
  const { ref } = useFocusable({ focusable: false })
  const location = useLocation()

  const { id: activeCategoryId, subtype } = extractInfo(
    location?.pathname,
    location?.state?.activePathname || '',
  )

  const handleSelectTVListItem = useCallback(
    (item) => () => {
      if (!item.isActive) {
        onSelectChannelsListItem(item)
      }
    },
    [onSelectChannelsListItem],
  )

  const handleBecameFocused = useCallback(
    (item) => (props) => {
      item.onBecameFocused(props)
    },
    [],
  )

  const renderItem = useCallback(
    ({ item }) => {
      if (item.isBackButton) {
        return (
          <BackButton
            focusKey={item.id}
            title={item.title}
            onFocus={handleBecameFocused(item)}
            onPress={onBackPress}
            style={item?.style}
          />
        )
      }

      return (
        <ChannelCategoryCard
          focusKey={item.id}
          heading={item.heading}
          style={item.style}
          onFocus={handleBecameFocused(item)}
          onPress={handleSelectTVListItem(item)}
        />
      )
    },
    [], // eslint-disable-line react-hooks/exhaustive-deps
  )

  return (
    <div ref={ref}>
      <ChannelListControlFocusable
        title={title}
        items={items}
        activeChannelId={subtype || activeCategoryId}
        renderItem={renderItem}
      />
    </div>
  )
}
export const CategoryListControl = memo<CategoryListControlProps>(CategoryListControlPure)

export default CategoryListControl
